<template>
  <footer class="footer-area bg-white text-center rounded-top-7">
    <p class="fs-14">
      © <span class="text-primary-div">SSMS</span> is Proudly Owned by
      <a
        href="https://envytheme.com/"
        target="_blank"
        class="text-decoration-none text-primary"
      >
        Telanusa
      </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
